export const RANK_CLASS = [
  'pd-best-for__rank-item--first',
  'pd-best-for__rank-item--second',
  'pd-best-for__rank-item--third',
];

export function decorateRegionalPerformance(perf) {
  if (!perf) {
    return { hasRegionalData: false };
  }
  return {
    hasRegionalData: true,
    responseTimeDisplay:
      perf.avg_response_time_ms !== null && perf.avg_response_time_ms !== undefined ? `${Math.round(perf.avg_response_time_ms)}ms` : '—',
    successRateDisplay: perf.avg_success_rate !== null && perf.avg_success_rate !== undefined ? `${perf.avg_success_rate}%` : '—',
    uptimeDisplay: perf.avg_uptime_percentage !== null && perf.avg_uptime_percentage !== undefined ? `${perf.avg_uptime_percentage}%` : '—',
    runCount: perf.run_count || 0,
  };
}
